import { computed, type MaybeRefOrGetter, toValue } from "vue";
import { useNutritionBasisStore } from "#/store/nutritionBasis";
import { useThemeStore } from "#/store/theme";
import { hasVisibleWeight, type NutritionAmounts, toNutritionsPer100g } from "#/utils/nutritions";

export function useNutritionBasis(portion: MaybeRefOrGetter<NutritionAmounts>, isVisible: MaybeRefOrGetter<boolean> = true) {
	const themeStore = useThemeStore();
	const basisStore = useNutritionBasisStore();

	const hasBasisToggle = computed(() => toValue(isVisible) && !!themeStore.data?.show_nutrition_per_100g && hasVisibleWeight(toValue(portion)));
	const nutritions = computed(() => (hasBasisToggle.value && basisStore.isPer100g ? toNutritionsPer100g(toValue(portion)) : toValue(portion)));

	return { hasBasisToggle, nutritions };
}
